import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { logger } from '@/services/logger/logger';
import { usePaymentsConfig } from '@/services/paymentsConfig/usePaymentsConfig';
import VerticalCentre from '@/components/verticalCentre/VerticalCentre';
import Loader from '@/components/loader/Loader';

const isNonProduction = import.meta.env.VITE_CLIENT === 'test';

function PaymentsConfigContainer({ children }: React.PropsWithChildren) {
  const { paymentsConfigData, paymentsConfigError, redirectIfActive } = usePaymentsConfig();

  const navigate = useNavigate();

  useEffect(() => {
    if (!paymentsConfigError) {
      return;
    }
    const errorMessage = 'Error loading payments configuration';
    logger.error(errorMessage);
    logger.error(paymentsConfigError);

    if (isNonProduction) {
      console.error(errorMessage, paymentsConfigError);
    }

    void navigate('/error', isNonProduction ? {
      state: {
        errorMessage,
        error: paymentsConfigError
      }
    } : undefined);
  }, [paymentsConfigError, navigate]);

  if (paymentsConfigError) {
    return null;
  }

  // If payments config is set to redirect away from this app, it will be executed here
  redirectIfActive();

  // Normally (when payment config is loaded) display the application
  if (paymentsConfigData) {
    return children;
  }

  // Show a loader while waiting for payment config to be ready
  return (
    <VerticalCentre>
      <Loader />
    </VerticalCentre>
  );
}

export default PaymentsConfigContainer;
